import React from "react";
import PropTypes from "prop-types";

import "./SettingsLayout.scss";

const SettingsSection = ({ title, description, children }) => (
    <section className="settings-section">
        <header className="settings-section__header">
            <h3>{title}</h3>
            {description && <p>{description}</p>}
        </header>
        <div className="settings-section__content">
            {children}
        </div>
    </section>
);

SettingsSection.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    children: PropTypes.node.isRequired,
};

SettingsSection.defaultProps = {
    description: "",
};

export default SettingsSection;
